import React, { useState, useMemo } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "jspdf/dist/polyfills.es.js";
import EditableField from "./EditableField";

const useHover = () => {
  const [hovered, setHovered] = useState();

  const eventHandlers = useMemo(
    () => ({
      onMouseOver() {
        setHovered(true);
      },
      onMouseOut() {
        setHovered(false);
      },
    }),
    []
  );
  return [hovered, eventHandlers];
};

const WebCV = (props) => {
  const [cv, setCV] = useState({
    name: {
      default: "Full Name",
      value: "Darko Milevski",
    },
    avatar: {
      default:
        "https://www.sibberhuuske.nl/wp-content/uploads/2016/10/default-avatar.png?fbclid=IwAR3ohCaqwU-59D8GDRjff4TttyYumvDz4PXEL4HflKLYcq5Rh7Zd4xpgB-U",
      value:
        "https://scontent.fskp2-1.fna.fbcdn.net/v/t1.0-9/89554869_10212698287330816_7118086051695951872_o.jpg?_nc_cat=105&ccb=2&_nc_sid=174925&_nc_ohc=1ypo5KLkfGwAX9vsQ-k&_nc_ht=scontent.fskp2-1.fna&oh=445e2582442e39b1ad41f7cd1fc3ca1f&oe=601911B3",
    },
    title: {
      default: "Proffesional Title",
      value: "Entrepeneur,Engineer,Inventor and investitor",
    },
    about: {
      default: "About Me",
      value:
        "Aiming to reduce global warming throught sustainable energy production and consumption. Plannning to reduce the risk of human extincion by making life multi-planetary and setting up a human colony on Mars",
    },
    imageCV: {
      default: "Email",
      value: "elon@teslamotors.com",
    },
    inputMail: {
      default: "Email",
      value: "elon@teslamotors.com",
    },
    inputPhone: {
      default: "Phone number",
      value: "620-681-5000",
    },
    inputPlace: {
      default: "City,Country",
      value: "Los Angeles, USA",
    },
    inputTwitter: {
      default: "Twitter",
      value: "@milevskidare",
    },
    workBio: {
      default: "Work Experience",
      value: "Work Experience",
    },
    workPosition: {
      default: "Position/Title",
      value: "Founder,CEO & Lead Designer",
    },
    workPara: {
      default: "Accomplishment 1",
      value:
        "Successfully launched Falcon Heavey,the most powerful operational rocket in the world by a factor of two,with the ability to lift into orbit nearly 64 metric tons (141,000 ib) - a mass greater than a 737 jetliner loaded passanger,crew,luggage and fuel.",
    },
    workPara1: {
      default: "Task 1",
      value:
        "Plans to reduce space transportation cost to enable people to colonize Mars",
    },
    workPara2: {
      default: "Task 2",
      value:
        "Developed the Falcon 9 spacecraft,which replaced the space shuttle when he retired in 2011",
    },
    secondTitle: {
      default: "Title",
      value: "SKILLS & COMPETENCIES",
    },
    button: {
      default: "Skill 1",
      value: "Thinking throught first princiiples",
    },
    button1: {
      default: "Skill 2",
      value: "Marketing",
    },
    button2: {
      default: "Skill 3",
      value: "Micromenagement",
    },
    button3: {
      default: "Skill 4",
      value: "Goal oriented",
    },
    button4: {
      default: "Skill 5",
      value: "Resiliency",
    },
    button5: {
      default: "Another Skill",
      value: "Future focused",
    },
    button6: {
      default: "One More",
      value: "Leadership",
    },
    workEdu: {
      default: "Education",
      value: "Founder",
    },
    workInfo: {
      default: "Study",
      value: "The Boring Company",
    },
    workInfo1: {
      default: "Think Learned",
      value: "Raised $10m by selling 20.000 flamethrowers in 4 days.",
    },
    workInfo2: {
      default: "Think Learned-1",
      value: "Raised $10 by selling 50.000 baseball caps",
    },
    workInfo3: {
      default: "Think Learned-2",
      value:
        "Hyperloop -- an ultra high-speed underground public transporatiton sistem in which passengers are transported on autonomous electric pods traveling at 600+ miles per hour in a pressurized cabin.",
    },
    thirdTitle: {
      default: "ACHIEVEMENTS & CERTIFICATES",
      value: "ACHIEVEMENTS & CERTIFICATES",
    },
    paraAchievment: {
      default: "Achievement",
      value: "53rd Richest person in the world-Forbes (2018)",
    },
    paraAchievment1: {
      default: "Achievement1",
      value:
        "21st on the Forbes list of the World's Most Powerful People (2016)",
    },
    paraAchievment2: {
      default: "Achievement2",
      value: "IEEE Honorary Membership (2015)",
    },
    paraAchievment3: {
      default: "innerText",
      value:
        "Given to people who have rendered mercatorious service humanity in the IEEE's designated Fields of interest",
    },
    paraAchievment4: {
      default: "innerText",
      value: "Businessperson of The Year by Fortune Magazine (2013)",
    },
    fourthTitle: {
      default: "title",
      value: "CEO and Product Architect",
    },
    fourthSubtitle: {
      default: "para",
      value: "Tesla Inc",
    },
    fourthParaYear: {
      default: "Year",
      value: "2004-Present",
    },
    fourthDesc: {
      default: "Description",
      value: "Global sales passed 250,000 units in September 2017",
    },
    fourthDesc1: {
      default: "Description1",
      value:
        "Consumer Reports named Tesla as the top American car brand and ranked it 8th among global carmakers in February 2017",
    },
    fourthDesc2: {
      default: "Description2",
      value:
        "Topped Consumer Reports Annual Owner Satisfaction Survey at 91% in 2016.",
    },
    fourthTitle2: {
      default: "title2",
      value: "FAI Space Medal (2010)",
    },
    fourthSpan2: {
      default: "span",
      value:
        "One of the highest honors in the aerospace industry shared with person like Neil Armstrong and John Glem",
    },
    fourthTitle3: {
      default: "title3",
      value:
        "Honorary Doctorate in Design from the Art Center College of Design",
    },
    fourthTitle4: {
      default: "title4",
      value:
        "Honorary Doctorate (DUniv) in Aerospace Engineering from the University of Surrey.",
    },
    fourthTitle5: {
      default: "title5",
      value:
        "Honorary Doctorate of Engineering and Technology from Yale University",
    },
    fifthTitle: {
      default: "title",
      value: "Co-founder and Former Chairman",
    },
    fifthSubTitle: {
      default: "subtitle",
      value: "SolarCity(subsidiary of Tesla Inc.)",
    },
    fifthspan: {
      default: "span",
      value: "06/2005- Present",
    },
    fifthspan1: {
      default: "span1",
      value: "Accomplishments",
    },
    fifthPara: {
      default: "Info",
      value:
        "Merged the company with Tesla Inc. and now offers energy storage services through Tesla,Including a turnkey residential battery backup service that incorporates Tesla's Powerwall",
    },
    fifthPara1: {
      default: "Info1",
      value:
        "In 2015,installed 870MW of solar power,approximately 28% of non-utlity solar installation in the U.S, that year",
    },
    fifthTitle1: {
      default: "title",
      value: "Interest",
    },
    fifthOption: {
      default: "title",
      value: "Physics",
    },
    fifthOption1: {
      default: "title",
      value: "Sustainability",
    },
    fifthOption2: {
      default: "title",
      value: "Philanthropy",
    },
    fifthOption3: {
      default: "title",
      value: "Twitter",
    },
    fifthOption4: {
      default: "title",
      value: "Extraterresrial Life",
    },
    fifthOption5: {
      default: "title",
      value: "Alternative Energy",
    },
    fifthOption6: {
      default: "title",
      value: "Space Engineering",
    },
    fifthOption7: {
      default: "title",
      value: "Reading",
    },
    fifthOption8: {
      default: "title",
      value: "Video Games",
    },
    fifthOption9: {
      default: "title",
      value: "All",
    },
    sixTitle: {
      default: "title",
      value: "Founder & CEO",
    },
    sixSubTitle: {
      default: "subtitle",
      value: "Neurolink",
    },
    sixspan: {
      default: "year",
      value: "07/2016 - Present",
    },
    sixParagraph: {
      default: "year",
      value:
        "A company aims to make devices to treat serious brain diseases in the short-term,with the eventual goal of human enhancement.",
    },
  });

  const downloadPDF = () => {
    const page = document.getElementById("doctopdf");
    page.style.marginTop = "-" + page.offsetHeight * 1.3 + "px";
    html2canvas(page).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("DareMilevski.pdf");
      props.handleShow(true);
    });
  };

  return (
    <div id="doctopdf" className="WebCV">
      <div className="row p-4">
        <div className="col-md-1">
          <div className="box"></div>
        </div>
        <div className="col-md-4">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="name"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="title"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="about"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-3">
          <EditableField
            cv={cv}
            setCV={setCV}
            field="avatar"
            type="file"
            editMode={props.editMode}
            handleHover={props.handleHover}
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex justify-content-end">
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputMail"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <span className="ml-3">
              <i className="fas fa-envelope"></i>
            </span>
          </div>
          <div className="d-flex justify-content-end">
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputPhone"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <span className="ml-3">
              <i className="fas fa-phone"></i>
            </span>
          </div>
          <div className="d-flex justify-content-end">
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputPlace"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <span className="ml-3">
              <i className="fas fa-map-marker-alt"></i>
            </span>
          </div>
          <div className="d-flex justify-content-end">
            <div className="CVPARA">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputTwitter"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <span className="ml-3">
              <i className="fab fa-twitter"></i>
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div className="row p-4">
        <div className="col-md-1">
          <div className="box"></div>
        </div>
        <div className="col-md-6">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workBio"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPosition"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-5  innerInput">
          <div className="font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="secondTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>

          <div className="btn cvBtn m-2">
            <EditableField
              id="button"
              cv={cv}
              setCV={setCV}
              field="button"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn  cvBtn m-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="button1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn  cvBtn m-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="button2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn  cvBtn m-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="button3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn  cvBtn m-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="button4"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn  cvBtn m-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="button5"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="btn  cvBtn m-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="button6"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row p-4">
        <div className="col-md-1">
          <div className="box"></div>
        </div>
        <div className="col-md-6">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workEdu"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className=" CVPARA fontPara">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workInfo"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workInfo1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workInfo2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workInfo3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-5 ">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="thirdTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraAchievment"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraAchievment1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraAchievment2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="paraAchievment3"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraAchievment4"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row p-4">
        <div className="col-md-1">
          <div className="box"></div>
        </div>
        <div className="col-md-6">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthSubtitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthParaYear"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthDesc"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthDesc1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthDesc2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-5">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthTitle2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="fourthSpan2"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthTitle3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthTitle4"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fourthTitle5"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row p-4">
        <div className="col-md-1">
          <div className="box"></div>
        </div>
        <div className="col-md-6">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fifthTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fifthSubTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="fontPara CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fifthspan"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fifthspan1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fifthPara"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="fifthPara1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-5 ">
          <div className="row">
            <div className="col-md-6 ">
              <div className="font-weight-bold CVPARA mainTitle">
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthTitle1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fas fa-user-md p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fas fa-mountain p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fab fa-phoenix-framework p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption2"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fab fa-twitter-square p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption3"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
            </div>
            <div className="col-md-6 ">
              <div className="py-3"></div>
              <div className="CVPARA p-1">
                <i className="fas fa-atom p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption4"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fas fa-rocket p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption5"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fas fa-book-open p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption6"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fas fa-book p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption7"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
              <div className="CVPARA p-1">
                <i className="fas fa-dice p-1 mr-1"></i>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="fifthOption8"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row p-4 mb-5">
        <div className="col-md-1">
          <div className="box"></div>
        </div>
        <div className="col-md-6">
          <div className="font-weight-bold CVPARA mainTitle">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="sixTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA fontPara">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="sixSubTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="fontPara CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="sixspan"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <i className="fas fa-square p-1"></i>
            <EditableField
              cv={cv}
              setCV={setCV}
              field="sixParagraph"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-5  innerInput"></div>
      </div>
      <div className="row mb-5">
        <div className="col-md-12 text-right  innerInput">
          <button
            className="btn buttonHome"
            data-html2canvas-ignore="true"
            onClick={downloadPDF}
          >
            DOWNLOAD
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebCV;
